import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog, Button, Link } from '@mui/material';
import { useAppState } from '../states/app-state';
import styles from './Notifier.module.scss';
import DisabledClickLoading from '../components/DisabledClickLoading'; // added by Bearer Web Developer

const Notifier: React.FunctionComponent<IProps> = observer((props) => {
  const appStore = useAppState();

  const { snackMessage } = appStore;
  // added by Bearer Web Developer start
  const [loading, setLoading] = useState(false);
  const handleClickaSync = async () => {
    if (snackMessage?.handleClick && snackMessage?.hasLoadingForHandleClick) {
      setLoading(true);
      await snackMessage?.handleClick()
      setLoading(false);
      appStore.setSnackMessage(undefined);
    }
  }
  const handleOpenningaSync = async () => {
    setLoading(true);
    if (snackMessage?.handleOpenning) {
      await snackMessage?.handleOpenning();
    }
    setLoading(false);
  }
  // added by Bearer Web Developer end

  const hide = () => {
    // appStore.setSnackMessage(undefined); // commented by Bearer Web Developer
    // added by Bearer Web Developer start
    if (snackMessage?.handleClick) {
      if (snackMessage?.hasLoadingForHandleClick) {
        handleClickaSync();
      } else {
        snackMessage?.handleClick();
        appStore.setSnackMessage(undefined);
      }
    } else {
      appStore.setSnackMessage(undefined);
    }
    // added by Bearer Web Developer end
  };
  // added by Bearer Web Developer start
  React.useEffect(() => {
    if (snackMessage?.handleOpenning && snackMessage?.hasLoadingForOpenning) {
      handleOpenningaSync();
    } else if (snackMessage?.handleOpenning) {
      snackMessage?.handleOpenning();
    }
  }, []);
  // added by Bearer Web Developer end

  // commented by Bearer Web Developer start
  // if (!snackMessage) {
  //   return null;
  // }
  // commented by Bearer Web Developer end

  return (
    // modified by Bearer Web Developer start
    <Dialog open={!!snackMessage} // true changed to !!snackMessage by Bearer Web Developer
      PaperProps={{ className: styles.root, style: { borderRadius: "10px" } }} >
      <p>{snackMessage?.message}</p>
      <div className={styles.buttons}>
        <Button onClick={hide} className={styles.button}>
          <span>{snackMessage?.buttonMessage || "OK"}</span>
        </Button>
        {loading && <DisabledClickLoading />} {/* added by Bearer Web Developer (for loading) */}
        {/* added by Bearer Web Developer start */}
        {snackMessage?.hasSopportLink &&
          <Link className={styles.support} target="_blank" href={appStore.webAppRemoteConfigParameters?.supportUrl}><span>Support</span></Link>
        }
        {/* added by Bearer Web Developer end */}
      </div>
    </Dialog>
    // modified by Bearer Web Developer end
    // <Snackbar
    //   anchorOrigin={{
    //     vertical: 'bottom',
    //     horizontal: 'left',
    //   }}
    //   open={true}
    //   autoHideDuration={6000}
    //   onClose={hide}
    //   ContentProps={{
    //     'aria-describedby': 'message-id',
    //   }}
    //   message={snackMessage.message}
    //   action={[
    //     <IconButton
    //       key="close"
    //       aria-label="Close"
    //       color="inherit"
    //       className={classes.close}
    //       onClick={hide}
    //     >
    //       <CloseIcon />
    //     </IconButton>,
    //   ]}
    // />
  );
});

interface IProps {
}

export default (Notifier);
